import React, { Component } from 'react';
import { inject } from 'mobx-react';
import CloudAzureConfigureExportPowershell from './CloudAzureConfigureExportPowershell';

@inject('$cloudExportWizard', '$auth', '$users')
export default class AzureCliSetup extends Component {
  render() {
    const { $cloudExportWizard } = this.props;
    const { form } = $cloudExportWizard;

    return <CloudAzureConfigureExportPowershell form={form} showHeading={false} />;
  }
}
